export const MODAL_KEYS = {
  paymentMethodAdd: 'paymentMethodAdd',
  cancelSubscriptionConfirm: 'cancelSubscriptionConfirm',
};
